import "./CompanyNewHeaderStyles.scss";
import $ from "jquery";
import { dnbComLog, getWindowS, isNotUndefined, LogSeverity, setCompanyInfoCookie, track_event } from "../FunctionsCore";
// From https://commons.wikimedia.org/wiki/File:Transparent.gif
// Not copyrighted or copyrightable
// @ts-expect-error Ignore
import transparentGifAssetInline from "../resources/Transparent.gif?assetInline";
// TODO Analytics is probably broken
const companyNewHeader = (companyNewHeaderParameter) => {
    const { companyInformationForCookie, companyProfileHeaderTitle } = companyNewHeaderParameter;
    $(() => {
        if (isNotUndefined(companyInformationForCookie)) {
            setCompanyInfoCookie(companyInformationForCookie);
        }
    });
    // https://stackoverflow.com/questions/6497992/removing-img-border/31418887#31418887
    $(".company-profile-header-logo").attr("src", transparentGifAssetInline);
    const claimedCompanyButtonElement = window.document.querySelector("button.claimedCompany");
    const claimThisCompanyButton = window.document.querySelector("a.claimThisCompany");
    if (claimedCompanyButtonElement !== null) {
        // Set prop39 when 'claimed' button or Login link is clicked
        claimedCompanyButtonElement.addEventListener("click", () => {
            try {
                const windowS = getWindowS();
                windowS.prop39 = `${companyProfileHeaderTitle} - claimed-company button clicked`;
                windowS.tl();
            }
            catch (er) {
                dnbComLog(LogSeverity.ERROR, er);
            }
        });
        const tooltiptextAElement = window.document.querySelector(".tooltiptext a");
        if (tooltiptextAElement === null) {
            throw new Error("tooltiptextAElement is null");
        }
        tooltiptextAElement.addEventListener("click", () => {
            try {
                const windowS = getWindowS();
                windowS.prop39 = `${companyProfileHeaderTitle} - claimed-company tooltip clicked`;
                windowS.tl();
            }
            catch (er) {
                dnbComLog(LogSeverity.ERROR, er);
            }
            track_event(`${companyProfileHeaderTitle} - log_into_acct_clicked`);
        });
    }
    if (claimThisCompanyButton !== null) {
        // Set prop38 when 'claim this company' button is clicked
        claimThisCompanyButton.addEventListener("click", () => {
            try {
                const windowS = getWindowS();
                windowS.prop38 = `${companyProfileHeaderTitle} - claim-this-company button clicked`;
                windowS.tl();
            }
            catch (er) {
                dnbComLog(LogSeverity.ERROR, er);
            }
        });
    }
};
export { companyNewHeader };
